/**
 * Mock dos dados da área selecionada - Estrutura do Back-end
 * Este mock simula a estrutura completa de dados que viria da API
 * quando uma área é selecionada no mapa
 */

export const mockSelectedAreaData = {
  // Dados básicos da área
  id: "area_001",
  identificationCode: "P001",
  type: "PASTAGEM",
  color: "#FF0000",
  areaInSquareMeters: 10000,
  areaInHectares: 1.0,
  observation: "Área de pastagem principal com boa drenagem",

  // Dados do piquete (quando associado)
  picketId: "picket_001",
  picketName: "Piquete Norte",
  retreatId: "retreat_001",
  retreatName: "Retiro Central",

  // Status e atividade
  picketStatus: "P", // Pasturage (B, P, R, M, L, D, X, I)
  picketProductionSubSystem: "Extensive", // Extensive, SemiIntensive, Intensive
  picketStatusDays: 30, // dias no picketStatus atual
  picketStatusStartDate: "2024-02-15T00:00:00Z",

  // Dados do pasto (simplificado)
  picketPastureId: "pasture_001",
  picketPastureName: "Brachiaria brizantha - Marandu",

  // Taxa de lotação (para extensivo/semi-intensivo)
  stockingRate: 2.5, // UA/ha

  // Informações de animais atuais
  currentAnimals: {
    total: 45,
    male: 20,
    female: 25,
    statistics: {
      male: {
        averageWeight: 450,
        averageGdp: 1.2,
        averageAge: 18
      },
      female: {
        averageWeight: 380,
        averageGdp: 0.8,
        averageAge: 24
      }
    }
  },

  // Histórico de lotes
  lotHistories: [
    {
      id: "lot_history_001",
      lot: {
        id: "lot_001",
        name: "Lote A",
        code: "LTA001"
      },
      dateInUser: "2024-01-15T00:00:00Z",
      dateOutUser: "2024-03-20T00:00:00Z",
      totalDays: 65,
      animalCount: 50,
      averageWeight: 420
    },
    {
      id: "lot_history_002",
      lot: {
        id: "lot_002",
        name: "Lote B",
        code: "LTB001"
      },
      dateInUser: "2024-03-21T00:00:00Z",
      dateOutUser: null,
      totalDays: 15,
      animalCount: 45,
      averageWeight: 415
    }
  ],

  // Observações do piquete
  picketObservations: [
    {
      id: "obs_001",
      date: "2024-03-15T10:30:00Z",
      description: "Área em bom estado de conservação, pasto com boa cobertura",
      author: {
        id: "user_001",
        name: "João Silva",
        role: "Gerente de Campo"
      },
      type: "general",
      priority: "normal"
    },
    {
      id: "obs_002",
      date: "2024-02-28T14:15:00Z",
      description: "Necessário adubação na próxima estação chuvosa",
      author: {
        id: "user_002",
        name: "Maria Santos",
        role: "Técnico Agrícola"
      },
      type: "maintenance",
      priority: "high"
    },
    {
      id: "obs_003",
      date: "2024-02-10T09:00:00Z",
      description: "Identificada área com compactação do solo, necessário subsolagem",
      author: {
        id: "user_001",
        name: "João Silva",
        role: "Gerente de Campo"
      },
      type: "soil",
      priority: "medium"
    }
  ],

  // Dados de geometria (coordenadas do polígono)
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [-46.123456, -23.123456],
        [-46.123500, -23.123456],
        [-46.123500, -23.123500],
        [-46.123456, -23.123500],
        [-46.123456, -23.123456]
      ]
    ]
  },

  // Metadados
  createdAt: "2023-10-01T00:00:00Z",
  updatedAt: "2024-03-15T10:30:00Z",
  createdBy: {
    id: "user_001",
    name: "João Silva"
  },
  updatedBy: {
    id: "user_002",
    name: "Maria Santos"
  },

  // Dados de produção (para histórico)
  productionHistory: [
    {
      id: "prod_001",
      period: "2024-01",
      totalAnimals: 50,
      averageWeight: 420,
      totalWeight: 21000,
      stockingRate: 2.5,
      forageProduction: 1200 // kg/ha
    },
    {
      id: "prod_002",
      period: "2024-02",
      totalAnimals: 48,
      averageWeight: 415,
      totalWeight: 19920,
      stockingRate: 2.4,
      forageProduction: 1150
    }
  ]
};

/**
 * Mock para área sem piquete (apenas dados básicos)
 */
export const mockSelectedAreaDataWithoutPicket = {
  // Dados básicos da área
  id: "area_002",
  identificationCode: "A002",
  type: "BENFEITORIAS",
  color: "#00FF00",
  areaInSquareMeters: 5000,
  areaInHectares: 0.5,
  observation: "Área de benfeitorias - galpão de máquinas",

  // Sem dados de piquete
  picketId: null,
  picketName: null,
  retreatId: null,
  retreatName: null,
  picketPastureId: null,
  picketPastureName: null,

  // Status e atividade
  picketStatus: "M", // Maintenance
  picketProductionSubSystem: null,
  picketStatusDays: 2,
  picketStatusStartDate: "2024-03-13T00:00:00Z",

  // Dados de geometria
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [-46.123600, -23.123600],
        [-46.123650, -23.123600],
        [-46.123650, -23.123650],
        [-46.123600, -23.123650],
        [-46.123600, -23.123600]
      ]
    ]
  },

  // Metadados
  createdAt: "2023-11-01T00:00:00Z",
  updatedAt: "2024-03-13T08:00:00Z",
  createdBy: {
    id: "user_001",
    name: "João Silva"
  },
  updatedBy: {
    id: "user_003",
    name: "Carlos Oliveira"
  }
};

/**
 * Mock para área intensiva
 */
export const mockSelectedAreaDataIntensive = {
  // Dados básicos da área
  id: "area_003",
  identificationCode: "I001",
  type: "CONFINAMENTO",
  color: "#0000FF",
  areaInSquareMeters: 2000,
  areaInHectares: 0.2,
  observation: "Confinamento com sistema de alimentação automatizada",

  // Dados do piquete
  picketId: "picket_003",
  picketName: "Baia 01",
  retreatId: "retreat_002",
  retreatName: "Retiro Confinamento",

  // Status e atividade
  picketStatus: "P", // Pasturage
  picketProductionSubSystem: "Intensive",
  picketStatusDays: 45,
  picketStatusStartDate: "2024-01-30T00:00:00Z",

  // Sem dados de pasto (intensivo)
  picketPastureId: null,
  picketPastureName: null,
  stockingRate: null,

  // Informações de animais atuais
  currentAnimals: {
    total: 80,
    male: 80,
    female: 0,
    statistics: {
      male: {
        averageWeight: 520,
        averageGdp: 1.8,
        averageAge: 12
      },
      female: {
        averageWeight: 0,
        averageGdp: 0,
        averageAge: 0
      }
    }
  },

  // Histórico de lotes
  lotHistories: [
    {
      id: "lot_history_003",
      lot: {
        id: "lot_003",
        name: "Lote Confinamento A",
        code: "LCA001"
      },
      dateInUser: "2024-01-30T00:00:00Z",
      dateOutUser: null,
      totalDays: 45,
      animalCount: 80,
      averageWeight: 520
    }
  ],

  // Observações do piquete
  picketObservations: [
    {
      id: "obs_004",
      date: "2024-03-10T16:00:00Z",
      description: "Sistema de alimentação funcionando perfeitamente",
      author: {
        id: "user_004",
        name: "Ana Costa",
        role: "Técnico em Confinamento"
      },
      type: "equipment",
      priority: "normal"
    }
  ],

  // Dados de geometria
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [-46.123700, -23.123700],
        [-46.123750, -23.123700],
        [-46.123750, -23.123750],
        [-46.123700, -23.123750],
        [-46.123700, -23.123700]
      ]
    ]
  },

  // Metadados
  createdAt: "2024-01-01T00:00:00Z",
  updatedAt: "2024-03-10T16:00:00Z",
  createdBy: {
    id: "user_001",
    name: "João Silva"
  },
  updatedBy: {
    id: "user_004",
    name: "Ana Costa"
  }
};

/**
 * Função para obter mock baseado no tipo de área
 */
export const getMockAreaData = (areaType = 'Extensive') => {
  switch (areaType) {
    case 'Intensive':
      return mockSelectedAreaDataIntensive;
    case 'withoutPicket':
      return mockSelectedAreaDataWithoutPicket;
    case 'Extensive':
    default:
      return mockSelectedAreaData;
  }
};
